module.exports = __webpack_public_path__ + "static/media/promo-code-tooltip.a85093dc.png";